import { render, staticRenderFns } from "./CLocalesDropdown.vue?vue&type=template&id=7c8a5c78&"
import script from "./CLocalesDropdown.vue?vue&type=script&lang=js&"
export * from "./CLocalesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports